import * as React from "react"; // tslint:disable-line
import styled from "styled-components";

interface UnderlineProps {
  children: React.ReactNode;
  fontWeight?: number;
  textColor?: string;
  onClick?: () => void;
}

export const UnderlineLink = (props: UnderlineProps) => {
  return <UnderlineWrapper {...props}>{props.children}</UnderlineWrapper>;
};

const UnderlineWrapper = styled.label<UnderlineProps>`
  text-decoration: underline;
  cursor: pointer;
  ${(props) => (props.fontWeight ? `font-weight: ${props.fontWeight}` : "")};
  ${(props) => (props.textColor ? `color: ${props.textColor}` : "")};
`;
